import { TwoGisGeocodeResponseT, YandexGeocodeResponseT } from '@/core/types/geocoder.types'

// [latitude, longitude]
export default function () {
    function unwrapTwoGisCoords(point: { lat: number; lon: number }): number[] {
        const coordinates = [point.lat, point.lon]
        return coordinates
    }

    function unwrapYandexCoords(pos: string): number[] {
        const splitted = pos.split(' ')
        const coordinates = [Number(splitted[1]), Number(splitted[0])]
        return coordinates
    }

    function getCoordsFromResponse(
        response: YandexGeocodeResponseT | TwoGisGeocodeResponseT
    ): number[] | null {
        if ('result' in response) {
            const result = response.result

            if (!result) {
                return null
            }

            return unwrapTwoGisCoords(result.items[0].point)
        }

        if ('response' in response) {
            const yandex_response = response.response

            if (!yandex_response) {
                return null
            }

            return unwrapYandexCoords(
                yandex_response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos
            )
        }

        return null
    }

    return {
        unwrapTwoGisCoords,
        unwrapYandexCoords,
        getCoordsFromResponse,
    }
}
